(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["celestic-early-bf"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.countdownInitialized) return;
      root.dataset.countdownInitialized = 'true';
      const motionRegions = root.querySelectorAll('[data-bf-motion], .celestic-bf__gift-art');
      if ('IntersectionObserver' in window) {
        const motionObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => entry.target.classList.toggle('bf-motion-active', entry.isIntersecting));
        }, { rootMargin: '120px 0px', threshold: 0 });
        motionRegions.forEach((region) => motionObserver.observe(region));
      } else {
        motionRegions.forEach((region) => region.classList.add('bf-motion-active'));
      }
      const launch = Date.parse(root.dataset.launch);
      const fields = {
        days: root.querySelector('[data-bf-days]'),
        hours: root.querySelector('[data-bf-hours]'),
        minutes: root.querySelector('[data-bf-minutes]'),
        seconds: root.querySelector('[data-bf-seconds]')
      };
      const update = () => {
        if (!root.isConnected) return false;
        const seconds = Math.max(0, Math.floor((launch - Date.now()) / 1000));
        const values = {
          days: Math.floor(seconds / 86400),
          hours: Math.floor(seconds / 3600) % 24,
          minutes: Math.floor(seconds / 60) % 60,
          seconds: seconds % 60
        };
        Object.entries(values).forEach(([key, value]) => {
          if (fields[key]) fields[key].textContent = String(value).padStart(2, '0');
        });
        if (seconds === 0) {
          root.querySelector('.celestic-bf__clock').hidden = true;
          root.querySelector('[data-bf-countdown-label]').hidden = true;
          root.querySelector('[data-bf-live]').hidden = false;
          return false;
        }
        return true;
      };
      if (update()) {
        const interval = window.setInterval(() => {
          if (!update()) window.clearInterval(interval);
        }, 1000);
      }
    };
    document.querySelectorAll('[data-celestic-bf]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-celestic-bf]').forEach(initialize);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["celestic-gift-card"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('celestic-gift-card')) {
  customElements.define('celestic-gift-card', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const recipientFields = this.querySelector('.recipient-fields');
      if (recipientFields && !recipientFields.querySelector('.cgc__recipient-content')) {
        const content = document.createElement('div');
        content.className = 'cgc__recipient-content';
        while (recipientFields.firstChild) content.appendChild(recipientFields.firstChild);
        recipientFields.appendChild(content);
      }
      this.addEventListener('change', (event) => {
        const input = event.target.closest('.cgc__radio');
        if (!input) return;
        this.querySelector('input[name="id"]').value = input.value;
        this.querySelector('[data-gift-price]').textContent = input.dataset.price;
        this.querySelector('[data-gift-amount]').textContent = input.dataset.title;
        this.querySelector('.cgc__card').dataset.cardIndex = input.dataset.cardIndex;
        const image = this.querySelector('.cgc__image');
        if (image && input.dataset.image) {
          image.removeAttribute('srcset');
          image.src = input.dataset.image;
          image.alt = input.dataset.title;
        }
        const recipient = this.querySelector('recipient-form');
        if (recipient) {
          recipient.dataset.productVariantId = input.value;
          recipient.currentProductVariantId = input.value;
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        window.history.replaceState({}, '', url);
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Add transparent header toggle
      const headerWrapper = document.querySelector('.header-wrapper');
      if (scrollTop > 50) {
        headerWrapper.classList.add('scrolled-past-header');
      } else {
        headerWrapper.classList.remove('scrolled-past-header');
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
